import React from "react";
import type {SxProps, Theme} from "@mui/material/styles";
import {DataGrid} from "@mui/x-data-grid/DataGrid";
import {CPSMessages} from "commonUtils/enumerations";
import type {
  GridCallbackDetails,
  GridPaginationModel,
  GridRowHeightParams,
  GridRowHeightReturnValue,
  GridRowIdGetter,
} from "@mui/x-data-grid";
import {GridOverlay} from "@mui/x-data-grid";
import {DATA_GRID_SORT_ORDER} from "config/constants";

interface Props {
  getRowHeight?: (
    params: GridRowHeightParams,
  ) => GridRowHeightReturnValue | undefined;
  sx: SxProps<Theme> | undefined;
  getRowId: GridRowIdGetter<any>;
  viewAllRecords: any;
  columns: any;
  hideFooter: boolean;
  loader: boolean;
  paginationModel?: any;
  onSortModelChange?: any;
  onPaginationModelChange?:
    | ((model: GridPaginationModel, details: GridCallbackDetails<any>) => void)
    | undefined;
}

const CommonDataGrid: React.FC<Props> = ({
  getRowHeight,
  sx,
  getRowId,
  viewAllRecords,
  columns,
  hideFooter,
  loader,
  paginationModel,
  onSortModelChange,
  onPaginationModelChange,
}) => {
  const rowsPerPageOptions = [
    {value: 10, label: "10"},
    {value: 25, label: "25"},
    {value: 50, label: "50"},
    {value: 100, label: "100"}, // The DataGrid (MIT license) is limited to pages of up to 100 rows.
  ];

  const CustomNoRowsOverlay = () => {
    return (
      <GridOverlay className="records-not-found-viewall">
        {CPSMessages.DASHBOARDMSGNODATA}
      </GridOverlay>
    );
  };

  return (
    <DataGrid
      sortingOrder={DATA_GRID_SORT_ORDER}
      getRowId={getRowId}
      getRowHeight={getRowHeight}
      sx={sx}
      rows={viewAllRecords}
      slots={{
        noRowsOverlay: CustomNoRowsOverlay,
      }}
      rowCount={100} // The DataGrid (MIT license) is limited to pages of up to 100 rows.
      columns={columns}
      disableColumnSelector
      hideFooter={hideFooter}
      loading={loader}
      initialState={{
        pagination: {
          paginationModel: {
            page: paginationModel?.page,
            pageSize: paginationModel?.pageSize,
          },
        },
      }}
      pageSizeOptions={rowsPerPageOptions}
      paginationMode="server"
      sortingMode="server"
      onSortModelChange={onSortModelChange}
      onPaginationModelChange={onPaginationModelChange}
      slotProps={{pagination: {labelRowsPerPage: "Rows per Page"}}}
    />
  );
};

export default CommonDataGrid;
